<template>
  <GlobalWindow
    :title="title"
    :visible.sync="visible"
    :confirm-working="isWorking"
    @confirm="confirm"
    width="600px"
  >
    <el-form :model="form" ref="form" :rules="rules" label-width="120px">
      <el-form-item label="强制还车原因" prop="name">
        <el-input v-model="form.name" placeholder="请输入强制还车原因" v-trim/>
      </el-form-item>
      <el-form-item label="备注是否必填" prop="required">
        <el-radio-group v-model="form.required">
          <el-radio :label="0">否</el-radio>
          <el-radio :label="1">是</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="排序码（升序）" prop="sortnum">
        <el-input v-model="form.sortnum" placeholder="请输入排序码（升序）" v-trim/>
      </el-form-item>
    </el-form>
  </GlobalWindow>
</template>

<script>
import BaseOpera from '@/components/base/BaseOpera'
import GlobalWindow from '@/components/common/GlobalWindow'
export default {
  name: 'OperaBikeErrorWindow',
  extends: BaseOpera,
  components: { GlobalWindow },
  data () {
    return {
      // 表单数据
      form: {
        id: null,
        name: '',
        sortnum: '',
        type: '',

        status: '',
        info: '',
        required: 0
      },
      // 验证规则
      rules: {
        name: [
          { required: true, message: '请输入时长减免原因', tigger: 'blur' },
        ]
      }
    }
  },
  created () {
    this.config({
      api: '/business/baseParam',
      'field.id': 'id'
    })
  },
  methods: {
    open (title, target, type=1) {
      this.title = title
      this.visible = true
      // 新建
      if (target == null) {
        this.$nextTick(() => {
          this.$refs.form.resetFields()
          this.form[this.configData['field.id']] = null
          this.form.type = type
        })
        return
      }
      // 编辑
      this.$nextTick(() => {
        for (const key in this.form) {
          this.form[key] = target[key]
        }
        this.form.type = type
      })
    },
  },
}
</script>
